import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  LabelList,
} from "recharts";

interface RadarChartComponentProps {
  data?: { subject: string; A: number }[];
  name: string;
  isCardView?: boolean;
  point: string;
}

const RadarChartComponent: React.FC<RadarChartComponentProps> = ({
  data,
  name,
  isCardView,
  point,
}) => {
  const theme = useTheme();

  const renderCustomizedLabel = (props: any) => {
    const { x, y, value } = props;
    return (
      <text
        x={x}
        y={y}
        fill={value < 70 ? theme.palette.error.dark : "#6b7aff"}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={20}
        fontWeight={600}
      >
        {value}
      </text>
    );
  };

  return (
    <Box
      sx={{
        width: isCardView ? "80px" : "100%",
        height: 400,
        position: "relative",
        ".recharts-label-list tspan": {
          fontSize: "20px",
          margin: "5px",
          fill: "blue",
        },
        ".recharts-polar-radius-axis ": {
          display: "none",
        },
      }}
    >
      <Typography
        variant={isCardView ? "h5" : "h3"}
        sx={{
          position: "absolute",
          color: "#6b7aff",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 43,
        }}
      >
        {point}
      </Typography>

      <ResponsiveContainer>
        <RadarChart data={data} cx="50%" cy="50%" outerRadius="80%">
          <PolarGrid />
          {!isCardView && <PolarAngleAxis dataKey="subject" />}
          <PolarRadiusAxis angle={30} domain={[0, 100]} />
          {isCardView ? (
            <Radar
              name={name}
              dataKey="A"
              stroke="#82ca9d"
              fill="#82ca9d"
              fillOpacity={0.2}
            />
          ) : (
            <Radar
              name={name}
              dataKey="A"
              stroke="#82ca9d"
              fill="#82ca9d"
              fillOpacity={0.2}
            >
              <LabelList dataKey="A" content={renderCustomizedLabel} />
            </Radar>
          )}
        </RadarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default RadarChartComponent;
